export interface GeneralTranslations {
  TABLE: {
    ARBITROS: string;
    USUARIOS: string;
    REPRESENTENTANTES: string;
    EDITAR_REPRESENTANTE: string;
    BUSCADOR: string;
    CERRAR_SESION: string;
    EDITAR_ARBITRO: string;
    EDITAR_USUARIO: string;
    CASO: string;
    PAGOS: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const generalTranslations: { [language: string]: GeneralTranslations } = {
  en: {
    TABLE: {
      ARBITROS: "Arbitrators",
      USUARIOS: "Administrators",
      REPRESENTENTANTES: "Representatives",
      EDITAR_REPRESENTANTE: "Edit representative",
      BUSCADOR: "Arbitrator Search",
      CERRAR_SESION: "Log out",
      EDITAR_ARBITRO: "Edit administrator",
      EDITAR_USUARIO: "Edit profile",
      CASO: "Case",
      PAGOS: "Payments"
    },
  },
  es: {
    TABLE: {
      ARBITROS: "Árbitros",
      USUARIOS: "Administradores",      
      REPRESENTENTANTES: "Representantes",
      EDITAR_REPRESENTANTE: "Editar representante",
      BUSCADOR: "Buscador de Árbitros",
      CERRAR_SESION: "Cerrar sesión",
      EDITAR_ARBITRO: "Editar árbitro",
      EDITAR_USUARIO: "Editar perfil",
      CASO: "Caso",
      PAGOS: "Pagos"
    },
  }
};

